import React from "react";
import { Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import html2canvas from "html2canvas";

const GamePlayerCardModal = (props) => {
  const brandingDetails = JSON.parse(localStorage.getItem("branding"));
  const captureImage = () => {
    const modalContent = document.getElementById("playermoreinfo");

    if (modalContent) {
      html2canvas(modalContent).then((canvas) => {
        const image = canvas.toDataURL("image/png");

        // Create a download link
        const downloadLink = document.createElement("a");
        downloadLink.href = image;
        downloadLink.download = `MyClubtap-${props.playerCardData?.full_name}`;

        // Append the link to the document and trigger a click event
        document.body.appendChild(downloadLink);
        downloadLink.click();

        // Remove the link from the document
        document.body.removeChild(downloadLink);
      });
    }
  };
  return (
    <>
      <Modal
        show={props.show}
        onHide={props.handleClose}
        id="playermoreinfo"
        size="lg"
      >
        <div className="player_star_info">
          <div className="player_star_pic">
            <Link className="player_profile_url" to={(e) => e.preventDefault()}>
              <figure>
                {props.playerCardData?.is_avatar === 1 ? (
                  <img
                    src={`${process.env.REACT_APP_PLAYER_AVATAR_URL}${props.playerCardData.image}`}
                    alt="img"
                  />
                ) : (
                  <img
                    src={`${process.env.REACT_APP_UPLOAD_URL}player/${props.playerCardData?.image}`}
                    alt="img"
                  />
                )}
              </figure>
            </Link>

            <div className="player_description">
              <h3>{props.playerCardData?.full_name}</h3>
              <div className="player_game_name">
                {props.playerCardData?.position === 4 && (
                  <span>Wicket-Keeper</span>
                )}
                {props.playerCardData?.position === 1 && <span>Batter</span>}
                {props.playerCardData?.position === 3 && (
                  <span>All-Rounder</span>
                )}
                {props.playerCardData?.position === 2 && <span>Bowler</span>}
                ,&nbsp; {props.playerTeamName}
              </div>
              <div className="player_game_name">
                {props.clubDetails?.game_name}
              </div>
              <div className="player_game_name">
                Views: {props?.playerProfileView}
              </div>
            </div>
          </div>
          <div className="club_logo">
            <figure>
              {props.playerSponsor && (
                <img
                  src={`${process.env.REACT_APP_UPLOAD_URL}sponsor/${props.playerSponsor.logo}`}
                  alt="img"
                />
              )}
              {!props.playerSponsor && brandingDetails && (
                <img
                  src={`${process.env.REACT_APP_UPLOAD_URL}branding/${brandingDetails.logo}`}
                  alt="img"
                />
              )}
              {!brandingDetails && (
                <img src={`../images/small-brand-logo.jpg`} alt="img" />
              )}
            </figure>
          </div>
        </div>
        <ul className="game_progress_info">
          <li>
            <div className="progress_info">
              Fantasy Pts<strong>{props.playerCardModalData?.sum_fp}</strong>
            </div>
          </li>
          <li>
            <div className="progress_info">
              Fantasy Value<strong>${props.playerCardData.svalue}m</strong>
            </div>
          </li>
          <li>
            <div className="progress_info">
              Picked in Teams
              {props.userPaidForClub === 1 ? (
                <strong>{Math.round(props.playerSelected)}%</strong>
              ) : (
                <>
                  <br></br>
                  <Link
                    className="lock-img"
                    onClick={(event) => {
                      event.preventDefault();
                      props.handleGamePassModalShow();
                    }}
                  >
                    <img src="../images/lock-icon.png" alt="img" />
                  </Link>
                </>
              )}
            </div>
          </li>
        </ul>

        <div className="player-performance">
          <ul>
            <li>
              <div className="performancebox">
                Matches<strong>{props.playerCardModalData?.tot_match}</strong>
              </div>
            </li>
            <li>
              <div className="performancebox">
                Innings<strong>{props.playerCardModalData?.inning}</strong>
              </div>
            </li>
            <li>
              <div className="performancebox">
                Runs<strong>{props.playerCardModalData?.sum_rs}</strong>
              </div>
            </li>
            {props.clubDetails?.game_type === 3 && (
              <>
                <li>
                  <div className="performancebox">
                    Ones
                    <strong>
                      {props.playerCardModalData?.sum_ones ?? "-"}
                    </strong>
                  </div>
                </li>
                <li>
                  <div className="performancebox">
                    Twos
                    <strong>
                      {props.playerCardModalData?.sum_twos ?? "-"}
                    </strong>
                  </div>
                </li>
                <li>
                  <div className="performancebox">
                    Threes
                    <strong>
                      {props.playerCardModalData?.sum_threes ?? "-"}
                    </strong>
                  </div>
                </li>
                <li>
                  <div className="performancebox">
                    Fours
                    <strong>
                      {props.playerCardModalData?.sum_fours ?? "-"}
                    </strong>
                  </div>
                </li>
                <li>
                  <div className="performancebox">
                    Fives
                    <strong>
                      {props.playerCardModalData?.sum_fives ?? "-"}
                    </strong>
                  </div>
                </li>
                <li>
                  <div className="performancebox">
                    Sixes
                    <strong>
                      {props.playerCardModalData?.sum_sixes ?? "-"}
                    </strong>
                  </div>
                </li>
                <li>
                  <div className="performancebox">
                    Sevens
                    <strong>
                      {props.playerCardModalData?.sum_sevens ?? "-"}
                    </strong>
                  </div>
                </li>
                <li>
                  <div className="performancebox">
                    Eights
                    <strong>
                      {props.playerCardModalData?.sum_eights ?? "-"}
                    </strong>
                  </div>
                </li>
                <li>
                  <div className="performancebox">
                    Nines
                    <strong>
                      {props.playerCardModalData?.sum_nines ?? "-"}
                    </strong>
                  </div>
                </li>
                <li>
                  <div className="performancebox">
                    Outs
                    <strong>
                      {props.playerCardModalData?.sum_outs ?? "-"}
                    </strong>
                  </div>
                </li>
              </>
            )}

            {props.clubDetails?.game_type !== 3 && (
              <>
                <li>
                  <div className="performancebox">
                    Fours
                    <strong>
                      {props.playerCardModalData?.sum_fours ?? "-"}
                    </strong>
                  </div>
                </li>
                <li>
                  <div className="performancebox">
                    Sixes
                    <strong>
                      {props.playerCardModalData?.sum_sixes ?? "-"}
                    </strong>
                  </div>
                </li>
              </>
            )}
            <li>
              <div className="performancebox">
                Ducks<strong>{props.playerCardModalData?.sum_dks}</strong>
              </div>
            </li>
            <li>
              <div className="performancebox">
                Overs<strong>{props.playerCardModalData?.sum_overs}</strong>
              </div>
            </li>
            <li>
              <div className="performancebox">
                Maidens<strong>{props.playerCardModalData?.sum_mdns}</strong>
              </div>
            </li>
            <li>
              <div className="performancebox">
                Runs Given<strong>{props.playerCardModalData?.sum_rg}</strong>
              </div>
            </li>
            <li>
              <div className="performancebox">
                Wickets<strong>{props.playerCardModalData?.sum_wks}</strong>
              </div>
            </li>
            <li>
              <div className="performancebox">
                Hat-trick
                <strong>{props.playerCardModalData?.sum_hattrick}</strong>
              </div>
            </li>
            <li>
              <div className="performancebox">
                Catches<strong>{props.playerCardModalData?.sum_cs}</strong>
              </div>
            </li>
            <li>
              <div className="performancebox">
                Catches WK
                <strong>{props.playerCardModalData?.sum_cwk}</strong>
              </div>
            </li>
            <li>
              <div className="performancebox">
                Stumpings<strong>{props.playerCardModalData?.sum_sts}</strong>
              </div>
            </li>
            <li>
              <div className="performancebox">
                RO Direct
                <strong>{props.playerCardModalData?.sum_rods}</strong>
              </div>
            </li>
            <li>
              <div className="performancebox">
                RO Assist<strong>{props.playerCardModalData?.sum_roas}</strong>
              </div>
            </li>
          </ul>
          {props.playerSponsor?.name && (
            <div
              className="countdata"
              style={{
                backgroundColor: "#FFD43C",
                width: "100%",
                margin: "0px",
                padding: "7px 0px 1px",
              }}
            >
              <div className="gameweek-filter">
                <h4
                  style={{
                    color: "black",
                    fontSize: "16px",
                    fontWeight: "500",
                  }}
                >
                  Sponsor: {props.playerSponsor?.name}
                </h4>
              </div>
            </div>
          )}
        </div>

        <Modal.Footer>
          <div className="poweredby">
            Powered By
            <img src="/images/logo.png" alt="img" />
          </div>
          <div className="">
            <Link onClick={captureImage} className="border-btn">
              <i className="fas fa-download"></i>
            </Link>
            <Link
              className="border-btn"
              onClick={(e) => {
                e.preventDefault();
                props.handleClose();
              }}
            >
              <i className="fas fa-times"></i>
            </Link>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default GamePlayerCardModal;
